import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { environment } from '../../../../environments/environment';
import { VehiclesHelpQrService } from 'app/_services/vehicle-help-qrcode.service';
import { ReportsService } from 'app/_services/reports.service';
import { VehiclesFilesService } from 'app/_services/vehicles-files.service';
import { ToasterErrorService } from 'app/_services/toaster.service';

export interface IAction {
  label: string;
  actionListType: 'internal' | 'external';
  link: string;
}

export interface IDriverCheckReport {
  message: string;
  driver_check: any;
  driver_check_id: number;
  date: string;
}

export interface IVehicleActivityReport {
  message: string;
  latest_vehicle_activities: any;
}

@Component({
  selector: 'app-qr-landing-page',
  templateUrl: './qr-landing-page.component.html',
  styleUrls: ['./qr-landing-page.component.scss'],
  encapsulation: ViewEncapsulation.None
})

export class QrLandingPageComponent implements OnInit {
  isLoading: boolean = true;
  public vehicleId: string = '';
  public vehicleReg: string;
  public actionsList: IAction[];
  public driverCheckReport: IDriverCheckReport;
  public vehicleActivityReports: IVehicleActivityReport[] = [];
  constructor(private router: Router, private route: ActivatedRoute, private vehicleHelpQRService: VehiclesHelpQrService, private reportsService: ReportsService, private vehicleFileService: VehiclesFilesService, private toasterErrorService: ToasterErrorService,) { }

  ngOnInit() {
    this.route.queryParams.subscribe(params => {
      this.vehicleId = params['vehicle_id'];
      this.vehicleReg = params['registration'];
      this.vehicleHelpQRService.getLatestDriverCheck(this.vehicleReg)
        .subscribe(data => {
          this.driverCheckReport = data
          this.isLoading = false
        });
      this.vehicleHelpQRService.getLatestMOTCertCheck(this.vehicleReg)
        .subscribe(data => {
          this.vehicleActivityReports = data["latest_vehicle_activities"]
          this.isLoading = false
        });
    });

    this.actionsList = [
      {
        label: 'Start a Safety Inspection',
        actionListType: 'external',
        link: `${environment.safetyInspectionAppUrl}/app/vehicle-history/${this.vehicleId}`
      },
      {
        label: 'Datalive',
        actionListType: 'internal',
        link: '/'
      },

    ];
  }

  public actionClick(action: IAction) {
    console.log('Action clicked: ', action);
    if (action.actionListType === 'external') {
      window.location.href = action.link;
    } else {
      this.router.navigate(['/']);
    }

  }

  public downloadDriverCheck(action: IDriverCheckReport) {
    this.isLoading = true;
    // this.toasterErrorService.toasterSuccess('Creating PDF for download...');
    this.reportsService.getReportPdf(this.driverCheckReport.driver_check_id).subscribe(
      success => {
        this.isLoading = false;
        let parsedResponse = success;
        let _reportType: string = "driver-check";
        const _filename = _reportType + '-' + this.vehicleReg + '.pdf';
        this.downloadFileResponse(parsedResponse, _filename);
      },
      error => {
        this.isLoading = false;
        console.log(error);
        this.toasterErrorService.toasterErr(error);
      }
    );
  }

  public getStatus(status, activity_type) {
    if (activity_type === "SAFETY_INSPECTION") {
      const _status = Number(status);
      if (_status === 1) return "Cancelled";
      if (_status === 3) return "Incomplete";
      if (_status === 7) return "Complete";
      if (_status === 11) return "Complete - Internal QC Review";
      if (_status === 12) return "Complete - QC Done";
    } else if (status) {
      return status;
    }
    return "No status";
  };

  public downloadSIPdfLink(id: number, reg: string) {
    this.isLoading = true;

    this.vehicleFileService.getSafetyInspectionReportPdf(id, null).subscribe((data) => {
      this.downloadFileResponse(data, `safety-inspection-report_${id}_${reg}`);
      this.isLoading = false;
    }, err => {
      this.isLoading = false;
      this.toasterErrorService.toasterErr('Something when wrong with the PDF download');
    });

  };

  public getReadableReference(reference) {
    if (reference === "SAFETY_INSPECTION") {
      return "Safety Inspection Report"
    }
    if (reference === "MOT") {
      return "MOT Report"
    }
    if (reference === "VTG7") {
      return "Plating Certificate (VTG7)"
    }
    return reference
  };

  downloadFileResponse(response, filename?: string) {
    // Reusable PDF convert download link
    const _filename = filename ? `${filename}.pdf` : 'datalive-download.pdf';
    const blob = new Blob([response], { type: 'application/pdf' });
    const url = window.URL.createObjectURL(blob);
    console.log('NL PDF Parsed response: ', response);
    // @ts-ignore: Unreachable code error
    if (navigator.msSaveOrOpenBlob) {
      // @ts-ignore: Unreachable code error
      navigator.msSaveBlob(blob, _filename);
      // @ts-ignore: Unreachable code error
      navigator.msSaveBlob(blob);
    } else {
      const a = document.createElement('a');
      a.href = url;
      a.download = _filename;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    }
    window.URL.revokeObjectURL(url);
  }
}




// WEBPACK FOOTER //
// /Users/brianyoung/Documents/Development/hfg/datalive-core/gae-web/datalive/client/src/app/QR-code/components/qr-landing-page/qr-landing-page.component.ts